<template>
  <div v-if="renderComponent" class="box d-flex flex-column flex h100">
    <div class="app">
      <div id="content" class="app-content box-shadow-3">
        <div class="content-main">
          <div class="box">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Assigned Course Name</th>
                  <th scope="col">Assigned Time</th>
                  <th scope="col">Classes</th>
                  <th scope="col">Remove</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in assessmentstat" :key="item.assigned_time">
                  <td>{{ (item.assigned_course_name[0])}}</td>
                  <td>
                    <p>{{ format(item.assigned_time) }}</p>
                  </td>

                  <td class="centertd">
                    <span
                      v-if="item.classes && item.classes.length > 0"
                      v-tippy="{ theme: 'popover' }"
                      :title="listNames(item.classes, 'Classes')"
                    >
                      <i class="fas fa-chalkboard fa-fw"></i>
                      {{ (item.classes && item.classes.length) || 0 }}
                    </span>
                    <span
                      v-if="!(item.classes && item.classes.length > 0)"
                      class="text-extra-muted"
                    >None</span>
                  </td>
                  <td class="centertd">
                    <button
                      class="btn btn-sm btn-icon btn-subtle text-white ml-1"
                      v-tippy
                      title="Remove"
                      @click="deleting = item"
                    >
                      <i class="text-danger far fa-lg fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <ul id="example-1"></ul>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="deleteConfirm"
      :hide-header-close="true"
      :visible="deleting != false"
      v-if="deleting"
    >
      <template slot="modal-title">Delete Assignment Action</template>
      <div class="row px-4 py-2 text-md">
        <h5 class="pt-2 mb-0">
          Are you sure you want to delete the Assignment Action
          <strong
            class="text-theme"
          >"{{ deleting.assigned_course_name[0] }}"</strong>?
        </h5>
        <h5 class="py-2">
          This will have far-reaching effects, including the deletion of the following data:
          <br />
        </h5>
        <ul>
          <li class="text-theme">All Assessments in all classes</li>
        </ul>
        <h6 class="py-2">
          <span class="text-danger far faw fa-exclamation-triangle"></span>
          The operation will occur immediately, and cannot be canceled or reversed!
        </h6>
      </div>
      <div class="form-group pl-2 pr-3">
        <input type="text" v-model="deleteConfirm" class="form-control" />
        <small class="text-muted">To confirm, type the name of the assessment</small>
      </div>
      <template slot="modal-footer">
        <button class="btn btn-flat" @click="deleting = false" data-dismiss="modal">Cancel</button>
        <button
          class="btn btn-flat"
          :class="{ [deleting.assigned_course_name[0] != deleteConfirm ? 'btn-secondary' : 'btn-danger']: true }"
          data-dismiss="modal"
          @click="removeAssignmentAction(deleting)"
          :disabled="deleting.assigned_course_name[0] != deleteConfirm"
        >Delete</button>
      </template>
    </b-modal>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w60 {
  width: 60px;
}
.flex {
  background-color: white !important;
}
.centertd {
  text-align: center;
}
.close {
  display: none !important;
}
</style>

<script>
// libraries
import moment from "moment";

import AssessmentService from "@/services/AssessmentService";
import Notie from "@/services/NotieService";
import Store from "@/services/Store";
import FormatService from "@/services/FormatService";

export default {
  name: "AssessmentStat",

  props: ["user", "assessment"],

  data() {
    return {
      assessmentstat: [],
      filter: "",
      sortBy: null,
      sortDesc: false,
      loading: true,
      renderComponent: true,
      deleting: false,
      deleteConfirm: ""
    };
  },

  components: {},

  created() {
    this.loadData();
  },

  watch: {},

  methods: {
    loadData() {
      return AssessmentService.getAssessmentStat(this.assessment.id)
        .then(resp => {
          this.totalRows = resp.data.length;
          this.assessmentstat = resp.data;
          for (var i = 0, length = resp.data.length; i < length; i++) {
            if (resp.data[i].assigned_course_name.length == 0) {
              resp.data[i].assigned_course_name[0] = "Unknown";
            }
          }

          return resp.data;
        })
        .catch(err => {
          console.log(err);
          notie.error("Failed to load courses", err);
          return [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    format(date) {
      console.log(this.listNames(this.assessmentstat[0].classes, "classes"));
      return moment(date).format("M/D/YY h:mm:ss a");
    },
    refreshTable() {
      this.$forceUpdate();
    },
    listNames(objects, title) {
      if (objects && objects.length > 0) {
        let nameList = `${title}:<br /><br /><ul class='pl-4 pr-3'>`;
        _.each(objects, object => {
          nameList += `<li style="text-align: left;">${object.name}</li>`;
        });

        return nameList + "</ul>";
      } else {
        return "";
      }
    },
    removeAssignmentAction(asmtstat) {
      asmtstat.inProgress = true;
      AssessmentService.pullAssignmentAction(
        asmtstat.assigned_course_id,
        asmtstat.assigned_time
      )
        .then(resp => {
          Notie.info("Assessment deleted");
          this.deleting = false;
          this.loadData();
        })
        .catch(err => {
          Notie.error("Failed to delete assessment", err);
        })
        .finally(() => {
          item.inProgress = false;
          this.deleting = false;
          this.loadData();
        });
    }
  },
  refreshPage() {
    this.$forceUpdate();
    this.$loadData();
    console.log("refreshing table ");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/AssessmentStat.vue